import React from 'react';
import { bool, shape } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';

const CellContents = {
    [true]:  'Custom Rule',
    [false]: 'K2A Rule'
};

const CustomRuleCell = ({ row, ...props }) => (
    <Table.Cell {...props}>
        {CellContents[row.custom]}
    </Table.Cell>
);


CustomRuleCell.defaultProps = {
    row: {
        custom: true
    }
};

CustomRuleCell.propTypes = {
    row: shape({
        custom: bool
    })
};

export default CustomRuleCell;
